import { AUTH_SESSION, type AuthActions, type AuthState, LOGOUT } from './types';

const initialState: AuthState = {
  access_token: '',
  account_id: '',
  expires: 0,
  token_type: '',
  include: {
    patient: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      dateOfBirth: '',
      language: '',
      country: '',
    },
  },
};

export const authReducer = (state = initialState, action: AuthActions): AuthState => {
  switch (action.type) {
    case AUTH_SESSION:
      return {
        ...state,
        ...action.authSession,
      };
    case LOGOUT:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
